import {observable} from 'mobx';

export default class PluginSettings {
	/** @type {Boolean} */
	@observable is_enabled;
	/** @type {String} */
	@observable output_wa_hook;

	constructor(settings) {
		if (settings) {
			this.is_enabled = settings.is_enabled;
			this.output_wa_hook = settings.output_wa_hook;
		}
	}
}